import React from 'react'
import mitt from 'mitt'

/**
 * Create the event context
 */
const EmitterContext = React.createContext({
  events: mitt()
})

/**
 * Passes EmitterContext's events as a prop to allow the components to use the emitters.
 */
const connectEmitter = Component => props => (
  <EmitterContext.Consumer>
    {
      (context = {
        events: {
          emit: () => {
            console.warn('context did not receive events')
          },
          on: () => {
            console.warn('context did not receive events')
          },
          off: () => {
            console.warn('context did not receive events')
          }
        }
      }) => (
        <Component
          emitter={context.events}
          {...props}
        />
      )
    }
  </EmitterContext.Consumer>
)

/**
 * Emits a CreateEmitter event when rendered
 */
const Emit = connectEmitter(({
  type, emitter: { emit }, ...props
}) => { emit(type, props) })

export {
  EmitterContext,
  Emit,
  connectEmitter
}
